import { Tabs, TabItem as TabItemCreditas } from '@creditas/tabs'
import { styled, css } from '@creditas/stylitas'

const TabItem = styled(TabItemCreditas)`
  padding: 16px;
  margin: 24px;
  margin-bottom: 40px;

  ${props =>
    props.variant === 'selected' &&
    css`
      border-color: #3377bb;
      color: #3377bb;
    `}
`
export { Tabs, TabItem }
